import { render, staticRenderFns } from "./TheEnvironmentIndicator.vue?vue&type=template&id=1960a660&scoped=true&"
import script from "./TheEnvironmentIndicator.vue?vue&type=script&lang=ts&"
export * from "./TheEnvironmentIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./TheEnvironmentIndicator.vue?vue&type=style&index=0&id=1960a660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960a660",
  null
  
)

export default component.exports